/**
 * The `Card` component in this code snippet is a reusable React component that displays a card with an
 * image, title, and description, allowing customization of background color, text color, box shadow,
 * and image dimensions.
 * @returns The `Card` component is being returned, which consists of a styled card box (`CardBox`)
 * containing an image (`CardImageBar` and `CardImage`), a title (`CardTitle`), and a description
 * (`CardDesc`). The component takes in props such as image, imageWidth, imageHeight, title, desc,
 * backgroundColor, textColor, boxShadow, and className to customize the card appearance
 */
import React from "react";
import styled from "styled-components";

const Card = (props) => {
  const { img, imageWidth, imageHeight, title, desc, backgroundColor, textColor, boxShadow, className  } = props;
  return (
    <>
      <CardBox 
        backgroundColor={backgroundColor} 
        textColor={textColor} 
        boxShadow={boxShadow}
        className={className}
      >
        <CardImageBar>
          <CardImage src={img} imageWidth={imageWidth} imageHeight={imageHeight}/>
        </CardImageBar>
        <CardTitle>{title}</CardTitle>
        <CardDesc>{desc}</CardDesc>
      </CardBox>
    </>
  );
};

export default Card;

export const CardBox = styled.div`
  height: 300px;
  background-color: ${props => props.backgroundColor || 'white'};
  color: ${props => props.textColor || 'black'};
  box-shadow: ${props => props.boxShadow || 'none'};
  padding: 15px;
  border-radius: 15px;
`;

export const CardTitle = styled.h4`
  text-align: center;
`;

export const CardImageBar = styled.div`
  text-align: center; 
`;
export const CardImage = styled.img`
  width: ${props => props.imageWidth || '50px'};
  height: ${props => props.imageHeight || '50px'};
`;

export const CardDesc = styled.p`
  text-align: center;
`;
